// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"CreateEditEquipmentSchedule_titleContainer__2B_DC","assignButton":"CreateEditEquipmentSchedule_assignButton__2KxOu"};